let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("kO5Jx"), load("a3Uq6"), load("kHOMt"), load("hhss7"), load("ffEVr"), load("hmjlF")]).then(() => parcelRequire('hs7Sl'));